module.exports = __webpack_public_path__ + "empty_comment.png?1f262c52ba5b7abd23252e575d530b88";